import { Loader } from './Loader'
import percentageFormat from '@insided/control/utils/percentageFormat'
import KeyInsightCardComparisonStats from '@insided/deprecated-control/analytics/KeyInsightCardComparisonStats'

interface KeyInsightCardContentProps {
  comparisonTooltip?: string
  total?: number | string
  showComparisonUnavailable?: boolean
  percent?: number
  hideComparisonWithPreviousPeriod?: boolean
  isPercentage?: boolean
  isLoading: boolean
  isKeyInsightAvailable?: boolean
  keyInsightUnavailableMessage?: string
}

const isNumeric = (val: any): boolean => {
  return !(val instanceof Array) && (val - parseFloat(val) + 1) >= 0
}

const getDisplayValue = (total: number | string, isPercentage: boolean) => {
  if (!isNumeric(total) || !isPercentage) {
    return total
  }

  return percentageFormat(Number(total), { maximumFractionDigits: 2 })
}

const KeyInsightCardContent = ({
  percent,
  showComparisonUnavailable = false,
  comparisonTooltip,
  isLoading,
  hideComparisonWithPreviousPeriod = false,
  isKeyInsightAvailable = true,
  keyInsightUnavailableMessage,
  isPercentage = false,
  total = 0
}: KeyInsightCardContentProps) => {
  if (isLoading) {
    return <Loader />
  }

  if (!isKeyInsightAvailable) {
    return <div className='metric-data-not-tracked-text'>{keyInsightUnavailableMessage} </div>
  }

  return (
    <div className='metric-additional-data'>
      <div className='metric-count'>{getDisplayValue(total, isPercentage)}</div>
      {!hideComparisonWithPreviousPeriod && (
        <KeyInsightCardComparisonStats
          showComparisonUnavailable={showComparisonUnavailable}
          percent={percent}
          comparisonTooltip={comparisonTooltip}
        />
      )}
    </div>
  )
}

export default KeyInsightCardContent
